import { Environment } from "./environment.type";

const getEnvironment = (): Environment => {
  const environment = process.env.ENVIRONMENT as Environment;
  return environment;
};

export default getEnvironment;
